

import styles from "../css/LandingPage.module.css";
//import "../css/LandingPage.css";


import { useLocation, useParams } from "react-router-dom";

import HeroSection from "../components/LandingPageHeroSection";
import PAS from "../components/LandingPagePAS";
import FeatureFocused from "../components/LandingPageFeatureFocused";
import TestimonialDriven from "../components/LandingPageTestimonialDriven";
import LongFormContent from "../components/LandingPageLongFormContent";
import LeadCaptureForm from "../components/LandingPageLeadCaptureForm";


//import Navbar from "./common/Navbar";
//import Footer from "./common/Footer";
//import SEOMetaTags from "./common/SEOMetaTags";

import { LandingPageContextProvider, useLandingPage } from "../context/LandingPageContext";

import { FeatureTypeSelector, ProgramSelector, SubjectSelector, SubjectTypeSelector } from "@Beasted1010/pivotal-wisdom";


import { fromKebabCaseToCamelCase } from "../utilities/helpers";



// TODO: Repeating in Models folder on Server under landingPage.tsx
enum LandingPageTemplate {
  PAS = "PAS",
  HERO_SECTION = "HeroSection",
  FEATURE_FOCUSED = "FeatureFocused",
  LEAD_CAPTURE_FORM = "LeadCaptureForm",
  LONG_FORM_CONTENT = "LongFormContent",
  TESTIMONIAL_DRIVEN = "TestimonialDriven",
};


type LandingPageParams = {
  category: string; // TODO: TYPE (LandingPageCategory is a type that exists on Server... -- Add to Shared Repo)
  
  subjectType?: SubjectTypeSelector;
  subjectSelector?: SubjectSelector;
  programSelector?: ProgramSelector;
  featureSelector?: FeatureTypeSelector;

  toolName?: string,
}

function LandingPage() { // TODO: TYPE

  //const { subjectType: subjectType, subjectSelector, programSelector } = useParams<LandingPageParams>();
  //if( subjectType == null || subjectSelector == null || programSelector == null ) return <></>;


  // TODO: THIS WOHLE THING IS VERY HACKY AND SKETCHY w/ the Indexing being done...
  // ... Find a cleaner, more scalable, less error-prone / sketchy way...
  const location = useLocation();
  const params = location.pathname.split("/").filter(Boolean);

  // Extract parameters based on the expected structure
  let landingPageParams: LandingPageParams = { category: params[1] };

  if( params.length === 3 ) {
    landingPageParams.toolName = fromKebabCaseToCamelCase(params[2]);
  } else if( params.length >= 4 ) {
    landingPageParams.subjectType = fromKebabCaseToCamelCase(params[2]) as SubjectTypeSelector;
    landingPageParams.subjectSelector = fromKebabCaseToCamelCase(params[3]) as SubjectSelector;
    if( params.length >= 5 ) landingPageParams.programSelector = fromKebabCaseToCamelCase(params[4]) as ProgramSelector;
    if( params.length === 6 ) landingPageParams.featureSelector = fromKebabCaseToCamelCase(params[5]) as FeatureTypeSelector;
  }

  console.log( "Landing Page Params:", landingPageParams );

  if( !landingPageParams.category ) return <div>Invalid Path</div>;

  const category = landingPageParams.category;
  const identifier = {
    subjectType: landingPageParams.subjectType,
    subjectSelector: landingPageParams.subjectSelector,
    programSelector: landingPageParams.programSelector,
    featureSelector: landingPageParams.featureSelector,

    toolName: landingPageParams.toolName,
  };

  return (
    <>
      {/*<LandingPageContextProvider subjectType={subjectType} subjectSelector={subjectSelector} programSelector={programSelector} >*/}
      <LandingPageContextProvider category={category} identifier={identifier} >
        {/* TODO: Consider if this Component sufficient for the types of Headers I may have for Landing Pages */}
        {/*<Header content={<HeaderContent />} />*/}

        <Main />
      </LandingPageContextProvider>
    </>
  );
}

function HeaderContent() {
  return (
    <></>
  );
}

function Main() {

  const { landingPageData } = useLandingPage();
  console.log( "LANDING PAGE DATA", landingPageData );
  if( !landingPageData ) return <></>; // TODO: <Loading ... />

  let landingPageType: LandingPageTemplate; // TODO: TESTING
  //landingPageType = LandingPageTemplate.PAS;
  //landingPageType = LandingPageTemplate.HERO_SECTION;
  //landingPageType = LandingPageTemplate.FEATURE_FOCUSED;
  //landingPageType = LandingPageTemplate.LEAD_CAPTURE_FORM;
  //landingPageType = LandingPageTemplate.LONG_FORM_CONTENT;
  //landingPageType = LandingPageTemplate.TESTIMONIAL_DRIVEN;



  const renderTemplate = () => {
    switch( landingPageData.template ) {
      case LandingPageTemplate.PAS:
        return <PAS data={landingPageData.content} />;
      case LandingPageTemplate.HERO_SECTION:
        return <HeroSection data={landingPageData.content} />;
      case LandingPageTemplate.FEATURE_FOCUSED:
        return <FeatureFocused data={landingPageData.content} />;
      case LandingPageTemplate.LEAD_CAPTURE_FORM:
        return <LeadCaptureForm data={landingPageData.content} />;
      case LandingPageTemplate.LONG_FORM_CONTENT:
        return <LongFormContent data={landingPageData.content} />;
      case LandingPageTemplate.TESTIMONIAL_DRIVEN:
        return <TestimonialDriven data={landingPageData.content} />;
      default:
        return <div>Invalid template type</div>;
    }
  };

  return (
    /*<div className="landing-page">*/
    <div className={`platform_body ${styles.landingPage}`}>
      {/*
      <SEOMetaTags seoData={landingPageData.seo} />
      <Navbar navItems={landingPageData.navbar.links} logo={landingPageData.logo} />
      */}

      {/*<main className="main-content">*/}
      <main className={styles.mainContent}>
        {renderTemplate()}
      </main>

      {/*
      <Footer 
        text={landingPageData.footer.text} 
        links={landingPageData.footer.links} 
        socialLinks={landingPageData.footer.socialLinks} 
      />
      */}
    </div>
  );
};


export default LandingPage;



